// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"likeButtonStyles_iconButton__2eWn_","md":"likeButtonStyles_md__3yynB","lg":"likeButtonStyles_lg__O2KpA","selected":"likeButtonStyles_selected__hvKt9"};